/**
 * Default maximum quantity used when no MaximumQuantity is set on the product Behavior.
 */
export const DEFAULT_MAX_QUANTITY = 99999;
